<template>
  <div class="p-16">
    <div class="w-full max-w-md mx-auto">
      <FormCreate :processing="creating" @submit="handleContactListCreation" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { middleware } from '@/routes/guards';
import FormCreate from '@/components/ContactLists/FormCreate.vue';

export default {
  components: {
    FormCreate,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    creating: false,
  }),
  beforeRouteEnter: middleware('account-permission:create contact lists'),
  methods: {
    ...mapActions('ui/accountContactLists', {
      storeContactList: 'store',
    }),
    handleContactListCreation(formData) {
      this.creating = true;
      const { accountId } = this;
      this.storeContactList({ accountId, formData })
        .then(({ contactListId }) => {
          this.creating = false;
          this.redirectToContactList(contactListId);
        })
        .catch(() => {
          this.creating = false;
        });
    },
    redirectToContactList(contactListUuid) {
      this.$router.replace({
        name: 'accounts.contactLists.contactListUuid',
        params: { contactListUuid },
      });
    },
  },
};
</script>
